// extracted by mini-css-extract-plugin
var _1 = "g-logo__ut2il";
export { _1 as "gLogo" }
